import React from 'react';
import randomColor from 'randomcolor';

import { useSelector } from 'react-redux';
import { Cell, Pie, PieChart, Tooltip } from 'recharts';

const UserRoleChart = () => {
    const admin = useSelector((state) => state.admin);

    return ( 
        <PieChart height={250} width={300}>
            <Pie  data={admin.roles} dataKey="VALUE" nameKey="KEY" cx="50%" cy="50%"  outerRadius={80} fill="#8884d8" label>
                {admin.roles.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={randomColor()} />
                ))}
            </Pie>

            <Tooltip />
        </PieChart>
    );
};
 
export default UserRoleChart;
      
  
                              
